module.exports = __webpack_public_path__ + "2197a4506ac00777a3e6b81638dcc1fd.svg";